import consoleLogger from '../../logger/consoleLogger';
import { GameClient } from '../../gameClient/gameClient';
import { MaintenanceMode } from '../../maintenance/maintenanceMode';
import { SetMaintenanceDataCommand } from '../../gameClient/clientCommands/setMaintenanceDataCommand';
import { OnErrorCommand } from '../../gameClient/clientCommands/onErrorCommand';
import { WebCommands } from '../webCommands';
import { getEnrichedClusterConfig } from '../../general/cmdGetStartData';

const logger = consoleLogger.getPrefixedCopy('CMD_GET_MAINTENANCE_DATA');


export class GetMaintenanceDataHandler {
    public handle(): void {
        try {
            MaintenanceMode.getStateData()
                .then((data) => {
                    GameClient.getInstance().sendCommand(new SetMaintenanceDataCommand({
                        ...data,
                        cluster: getEnrichedClusterConfig()
                    }));
                })
                .catch((error) => {
                    GameClient.getInstance().sendCommand(new OnErrorCommand({
                        error: (<Error>error).message,
                        method: WebCommands.GET_MAINTENANCE_DATA
                    }));
                });
        } catch (error) {
            logger.error(error);
            window.Sentry.captureException(error);
        }
    }
}
